export default __webpack_public_path__ + "ecd885e164d9857110c54c768f0ddeec.svg";